import { gql } from '@apollo/client'

export const GET_PAYMENT_METHODS = gql`
    query b2c_get_payment_methods {
        b2c_get_payment_methods {
            id
            created_at
            card_data {
                expiry_month
                expiry_year
                number
            }
            variant
        }
    }
`
